import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      {/* Main Footer */}
      <div className="footer-main">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-section">
            <h3 className="footer-brand">Bricks & Brain</h3>
            <p className="footer-description">
              Building strong foundations with smart solutions. Your trusted partner in construction excellence.
            </p>
            <div className="social-links">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="LinkedIn">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="YouTube">
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4>Contact Us</h4>
            <ul className="contact-info">
              <li>
                <span className="contact-icon">
                  <i className="fas fa-map-marker-alt"></i>
                </span>
                <span>Vasai, Maharashtra, India</span>
              </li>
              <li>
                <span className="contact-icon">
                  <i className="fas fa-phone-alt"></i>
                </span>
                <a href="tel:+919049610819">+91 9049610819</a>
              </li>
              <li>
                <span className="contact-icon">
                  <i className="fas fa-envelope"></i>
                </span>
                <a href="mailto:sksubup@gmail.com">sksubup@gmail.com</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="footer-bottom">
        <p>&copy; 2025 Bricks & Brain. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
